import { c as _c } from "react/compiler-runtime";
import AppWidgetContext from '@shared/utils/context/AppWidgetContext';
import dynamic from 'next/dynamic';
import { useContext } from 'react';
import Modal, { ModalContent, ModalHeader } from '../components/HOC/Modal';

// Moderation reporting is only reachable from a signed-in menu, so it has no
// business in the root Provider chunk an anonymous visitor downloads.
const ReportModal = dynamic(() => import('../components/moderation/ReportModal'), {
  ssr: false
});

// Stripe-using modules are deferred — they pull `@stripe/stripe-js` which
// otherwise loads Stripe.js (and sets the m.stripe.com fraud cookie) on
// every page via the global Provider tree.
const PurchaseModal = dynamic(() => import('../components/common/PurchaseModal'), {
  ssr: false
});
const FoundersToken = dynamic(() => import('../components/products/FoundersToken').then(m => m.FoundersToken), {
  ssr: false
});
const AppWidgets = () => {
  const $ = _c(14);
  const {
    closeNewModerationReportModal,
    moderationReportData,
    purchaseModal,
    setPurchaseModal,
    foundersTokenModalOpen,
    dismissFoundersTokenModal
  } = useContext(AppWidgetContext);
  let t0;
  if ($[0] !== closeNewModerationReportModal || $[1] !== moderationReportData[0] || $[2] !== moderationReportData[1]) {
    t0 = moderationReportData[0] !== null && moderationReportData[1] !== null && <ReportModal closeHandler={closeNewModerationReportModal} moderationType={moderationReportData[0]} target={moderationReportData[1]} />;
    $[0] = closeNewModerationReportModal;
    $[1] = moderationReportData[0];
    $[2] = moderationReportData[1];
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== purchaseModal || $[5] !== setPurchaseModal) {
    t1 = purchaseModal?.isOpen === true && purchaseModal.product && <PurchaseModal product={purchaseModal.product} closeHandler={() => setPurchaseModal(false, null)} />;
    $[4] = purchaseModal;
    $[5] = setPurchaseModal;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== dismissFoundersTokenModal || $[8] !== foundersTokenModalOpen) {
    t2 = foundersTokenModalOpen && <Modal closeHandler={dismissFoundersTokenModal}><ModalHeader closeHandler={dismissFoundersTokenModal}><h2 className="text-xl font-semibold">Limited Time: Founders Token Sale</h2></ModalHeader><ModalContent><div className="max-h-96 overflow-y-auto"><FoundersToken /></div></ModalContent></Modal>;
    $[7] = dismissFoundersTokenModal;
    $[8] = foundersTokenModalOpen;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== t0 || $[11] !== t1 || $[12] !== t2) {
    t3 = <>{t0}{t1}{t2}</>;
    $[10] = t0;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
};
export default AppWidgets;